import { SvgMintCircle } from '@bazaar-marketplace/assets/mint-circle';

export function MintIndicator({ className }: { className?: string }) {
  return <SvgMintCircle className={className} />;
}
